import { SwitchCardField } from '@app/components/form/SwitchCardField';
import { useIntl } from 'react-intl';
import { tiktokDisclosureMessages as messages } from './tiktok-disclosure-messages';

/**
 * "Disclose video content" toggle with its description.
 * Form-only; the value is not sent to the TikTok API.
 */
export function TiktokDisclosureToggleRow() {
  const { $t } = useIntl();

  return (
    <SwitchCardField
      name="discloseVideoContent"
      label={$t(messages.discloseVideoContent)}
      description={$t(messages.disclosureDescription)}
    />
  );
}
